import { Button, Heading, Input, Text, VStack, HStack, Box, Divider, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { createMap, getMaps } from "../../features/creator/creatorSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function CreatorMapList() {

    const { maps, isLoading, isSuccessManipulating } = useSelector((state) => state.creator)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(getMaps())
    }, [])

    useEffect(() => { // Navigate on map create
        if (isSuccessManipulating)
            navigate(`/creator/edit?mapId=${maps[maps.length - 1]._id}`)
    }, [isSuccessManipulating])

    const [newMapName, setNewMapName] = useState('')
    const [isCreatingMap, setIsCreatingMap] = useState(false)

    function createNewMapButtonPressed() {
        setIsCreatingMap(true)
        dispatch(createMap({ name: newMapName }))
    }

    function openMapButtonPressed(map) {
        navigate(`/creator/edit?mapId=${map._id}`)
    }

    return (
        <Box maxW="400px" mx="auto" border="1px" borderColor="grey.600" p={4} borderRadius="md">
            <VStack spacing={4} align="stretch">
                <Heading as="h1" size="lg">Your maps:</Heading>

                {isLoading && !isCreatingMap ? (
                    <Box w="100%" textAlign="center" children={ <Spinner /> } />
                ) : maps.length > 0 ? maps.map((map, index) => (
                    <Box key={map._id} px={2}>
                        <HStack justify="space-between" align="center">
                            <Text pl={2} isTruncated>{map.name}</Text>
                            <Button colorScheme="blue" size="sm" onClick={() => openMapButtonPressed(map)}>Open</Button>
                        </HStack>
                        {index < maps.length - 1 && <Divider my={3} opacity="0.4" />}
                    </Box>
                )) : (
                    <Text>No maps. Create a new one below.</Text>
                )}

                <Divider my={3} opacity="0.6" />

                <Text>Create a new map:</Text>
                <HStack>
                    <Input
                        onChange={(e) => setNewMapName(e.target.value)}
                        value={newMapName}
                        placeholder="New map name"
                    />
                    <Button 
                        colorScheme="green" 
                        onClick={createNewMapButtonPressed}
                        isLoading={isLoading && isCreatingMap}
                    >
                        Create
                    </Button>
                </HStack>
            </VStack>
        </Box>
    )
}